import { useEffect, useState } from 'react';

import { Product } from '@savebetter/components';

import { Datasources } from '../context/DataSourceContext';
import { replaceCustomVars, varRegExp } from '../utils/replaceCustomVar';
interface UseCustomVarResult {
  resolvedText: string;
  textOpacityClass: string;
}

type UseCustomVar = (
  sourceText: string,
  contextProducts: Product[] | null,
  contextDatasources: Datasources | null
) => UseCustomVarResult;

/*
  This hook has been introduced to control the display of rendered customVars.
  Given a text with custom vars (see replaceCustomVar), we provide a result with resolved text and opacity 1
*/
export const useCustomVar: UseCustomVar = (sourceText, contextProducts, contextDatasources) => {
  const [textOpacityClass, setOpacityClass] = useState('opacity-0');
  const [resolvedText, setResolvedText] = useState(sourceText);

  useEffect(() => {
    const hasTextCustomVars = varRegExp.test(resolvedText);
    if (hasTextCustomVars) {
      setResolvedText(replaceCustomVars(sourceText, contextProducts, contextDatasources));
    } else if (!hasTextCustomVars && textOpacityClass === 'opacity-0') {
      setOpacityClass('opacity-1');
    }
  }, [textOpacityClass, sourceText, contextProducts, contextDatasources, resolvedText]);

  return {
    resolvedText,
    textOpacityClass
  };
};
